import React from 'react';
import { Icon } from '@saviynt/design-system';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { COLOR_PROFILES, TYPE } from './constant';

import './SpbTimeLine.css';

function SpbTimeLine({
  bgColor,
  type,
  kind,
  iconKind,
  iconSize,
  iconColor,
  showTail,
  className,
  isSidePanelHistory,
  dataTestId,
}) {
  const DASHED_FILLER_BLOCK_COUNT = 10;
  const spbTimeLineClass = classnames('SpbTimeLine', className);
  const spbTimeLineIconClass = classnames(
    'SpbTimeLine-icon',
    iconSize === 'xxxSmall'
      ? 'SpbTimeLine-icon--small'
      : 'SpbTimeLine-icon--large'
  );
  const iconStyle = {
    backgroundColor:
      type === TYPE.fill ? bgColor || COLOR_PROFILES[kind].fill : 'white',
    border:
      type === TYPE.outline
        ? `1px solid ${bgColor || COLOR_PROFILES[kind].outline}`
        : 'none',
  };

  const renderSpbTimeLineTail = () => {
    if (showTail && isSidePanelHistory) {
      return <div className='SpbTimeLine-tail--normal' />;
    }

    if (showTail && type === TYPE.fill) {
      return <div className='SpbTimeLine-tail--normal' />;
    }

    if (showTail && type === TYPE.outline) {
      return (
        <div className='SpbTimeLine-tail--dashed'>
          {[...Array(DASHED_FILLER_BLOCK_COUNT).keys()].map((key) => (
            <div key={key} className='SpbTimeLine-tailDashedBlocks' />
          ))}
        </div>
      );
    }

    return <span />;
  };

  const iconColorValue =
    iconColor ||
    (type === TYPE.fill && !COLOR_PROFILES[kind].overRideIconColor
      ? 'neutral-000'
      : COLOR_PROFILES[kind].icon);

  return (
    <div className={spbTimeLineClass} data-testid={dataTestId}>
      {renderSpbTimeLineTail()}
      <div style={iconStyle} className={spbTimeLineIconClass}>
        <Icon kind={iconKind} size={iconSize} color={iconColorValue} />
      </div>
    </div>
  );
}

SpbTimeLine.propTypes = {
  bgColor: PropTypes.string,
  type: PropTypes.oneOf(Object.values(TYPE)),
  kind: PropTypes.oneOf(Object.keys(COLOR_PROFILES)),
  iconKind: PropTypes.string.isRequired,
  iconSize: PropTypes.string,
  iconColor: PropTypes.string,
  showTail: PropTypes.bool,
  className: PropTypes.string,
  isSidePanelHistory: PropTypes.bool, // Added for side panel history tab
  dataTestId: PropTypes.string,
};

SpbTimeLine.defaultProps = {
  bgColor: null,
  type: TYPE.fill,
  kind: 'normal',
  iconSize: 'xSmall',
  iconColor: null,
  showTail: true,
  className: '',
  dataTestId: '',
  isSidePanelHistory: false, // Added for side panel history tab
};

export default SpbTimeLine;
